import { render, staticRenderFns } from "./academic_judge_management.vue?vue&type=template&id=c27f4238&scoped=true&"
import script from "./academic_judge_management.vue?vue&type=script&lang=js&"
export * from "./academic_judge_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_judge_management.vue?vue&type=style&index=0&id=c27f4238&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27f4238",
  null
  
)

export default component.exports